<ng-container *ngIf="masterGroup">
    <div class="master-ref flex flex-row align-middle mt-[2%]">
        <div class="master-title bg-tw-primary min-w-[35%]">
            <h1 class="w-full px-3 py-2 !text-base"> {{ master.identifier }}{{ master.marque ? " - " : "" }}{{ master.marque }} {{ master.designation ? " - " : "" }}{{ master.designation }} </h1>
            <button mat-icon-button *ngIf="isCppOrFab() && !master?.isOld" (click)="editMaster(master.identifier)"><mat-icon>edit</mat-icon></button>
        </div>
        <div class="separator border-t-[1px] border-gray-300 h-1px w-full mx-2"></div>
        <div class="justify-end w-[26%] text-tw-primary" *ngIf="(isAdmin() || isCppOrFab()) && !master.isOld">
            <!-- <button mat-stroked-button (click)="newChildProject(master.identifier)" class="!rounded-xl px-2">
                <div class="flex items-center">
                    <div class="h-[2.5em] mr-1">
                        <div class="inline-flex font-light text-4xl leading-[0.75em] mb-2 mx-auto">+</div>
                    </div>
                    <div class="h-[2.5em]">
                        <div class="inline-flex font-extralight leading-[0.6em]">{{ 'ADD_CHILD_PROJECT' | translate }} </div>
                    </div>
                </div>
            </button> -->
            <button class="flex items-center border-[1px] border-gray-300 rounded-xl gap-2 p-2 h-[2.5rem] font-bold" (click)="newChildProject(master.identifier)">
                <mat-icon>add</mat-icon>{{ 'ADD_CHILD_PROJECT' | translate }} </button>
        </div>
    </div>
    <table class="w-full">
        <thead>
            <tr>
                <!-- THUMB -->
                <th class="w-[5%] table-header"><span class="header-title">{{ 'THUMB' | translate }}</span></th>
                <!-- NAME -->
                <th class="w-[20%] table-header"><span class="header-title">{{ 'JOB_NAME' | translate }}</span></th>
                <!-- EASYDIADEM -->
                <th class="w-[5%] table-header"><!-- EasyDiadem? --><span class="header-title"></span></th>
                <!-- FLOW -->
                <th class="w-[5%] table-header"><!-- FLOW --><span class="header-title"></span></th>
                <!-- EXTERN -->
                <th class="w-[15%] table-header bordered"><span class="header-title pl-4">{{ 'EXTERN_STATE' | translate }}</span></th>
                <!-- INTERN -->
                <th class="w-[15%] table-header bordered" *ngIf="!isClient()"><span class="header-title pl-4">{{ 'INTERN_STATE' | translate }}</span></th>
                <!-- MEMBERS -->
                <th *ngIf="isClient()" class="w-[15%] table-header bordered"><span class="header-title pl-4">{{ 'APPROVAL.TITLE' | translate }}</span></th>
                <!-- LINKS -->
                <th class="w-auto table-header bordered"><span class="header-title pl-2">{{ 'SPLITVIEWS' | translate }}</span></th>
                <!-- DATE -->
                <th class="w-[10%] table-header"><span class="header-title px-4">{{ 'CREATION_DATE' | translate }}</span></th>
                <!-- ACTIONS -->
                <th class="w-[10%] table-header" *ngIf="!isClient()"><span class="header-title">{{ 'ACTIONS' | translate }}</span></th>
            </tr>
        </thead>
        <tbody>
            <!-- CHILD CARD -->
            <!-- <tr class="h-4"></tr> -->
            <tr class="min-h-[6em] border-b-gray-200 last:border-b-0 border-b-[1px] hover:bg-tw-primary hover:bg-opacity-20" *ngFor="let project of masterGroup.childs" app-project-child-card [project]="project"></tr>
        </tbody>
    </table>
</ng-container>